import React from "react";

const Checklist = ({ list }) => {
  return (
    // Render a checklist of items
    <div className="">
      <h6 className="txt-primary text-center mb-3">Checklists</h6>
      <ul className="list-group list-group-numbered list-group-item">
        {list.map((item, index) => (
          <li key={index} className="d-flex align-items-center mb-2">
            <input
              readOnly
              type="checkbox"
              id={`item-${index}`}
              className={`me-3 form-check-input ${
                item?.checked ? "checkbox-success" : ""
              }`}
              checked={item?.checked}
            />
            <label
              htmlFor={`item-${index}`}
              className="text-sm"
              style={{ fontSize: "10px" }}
            >
              {item?.desc}
            </label>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Checklist;
